<template>
	<div>
		<b-alert class="text-left" variant="danger" :show="!$CoreSettingsJs.emptyObjectValidation(error_message)" v-html="error_message" :class="fix_height ? 'alert-height' : ''"></b-alert>
		<b-alert class="text-left" variant="success" :show="!$CoreSettingsJs.emptyObjectValidation(success_message)" v-html="success_message" :class="fix_height ? 'alert-height' : ''"></b-alert>
		<b-alert class="text-left" variant="warning" :show="!$CoreSettingsJs.emptyObjectValidation(warning_message)" v-html="warning_message" :class="fix_height ? 'alert-height' : ''"></b-alert>
	</div>
</template>

<style scoped>
.alert-height {
	max-height: 100px;
	overflow: auto;
}
</style>

<script>
export default {
	name: "FormAlert",
	props: {
		error_message: null,
		success_message: null,
		warning_message: null,
		fix_height: {
			type: Boolean,
			default() {
				return false;
			}
		}
	}
};
</script>
